import React from 'react';
import './style.scss';

const Divider = () => <div className="divider" />;

export default Divider;
